import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import { Link } from '@reach/router';
import { Form as FormikForm } from 'formik';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import { ThemeContext } from '../../../contexts/Theme';
import {
  focusRing,
  fontSize,
  layout,
  radius,
  space,
} from '../../../theme/tokens';
import * as common from '../../common/elements/Form';

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 44rem;
  margin: 0 auto;
  padding: 0 ${layout.gutter};

  /* validation and server error messages */
  & > p,
  & > ${common.FieldGroup} > p {
    margin: ${space[1]} 0 0;
    font-size: ${fontSize.sm};
    color: ${({ theme }) => theme.errorMessage};
    text-align: center;
  }
`;

export const SignUpButton = styled(common.Button).attrs(({ $variant }) => ({
  $variant: $variant || 'brand',
}))`
  margin-top: ${space[4]};
`;

export const NextButton = styled(common.Button).attrs(({ $variant }) => ({
  $variant: $variant || 'brand',
}))`
  margin-top: ${space[4]};
`;

export const BackButton = styled.button`
  ${iconButtonStyles}
  position: absolute;
  top: ${space[3]};
  left: ${space[3]};
`;

export const BigArrowBackIcon = () => {
  const theme = useContext(ThemeContext);
  return (
    <ArrowBackRoundedIcon
      style={{ fontSize: '3.2rem', color: theme.headerColour }}
    />
  );
};

export const LoadingContainer = styled.div`
  margin-top: ${space[5]};
`;

export const CreateUserInput = styled(common.FieldInput)`
  font-size: ${fontSize.lg};
  padding: ${space[1]} 0;
`;

export const BackLink = styled(Link)`
  position: absolute;
  top: ${space[3]};
  left: ${space[3]};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${layout.touchTarget};
  min-height: ${layout.touchTarget};
  border-radius: ${radius.pill};
  ${focusRing}
`;

export const ResetForm = styled(Form)`
  min-height: 100vh;
  padding-top: ${space[8]};
  padding-bottom: ${space[5]};
`;

export const Success = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[3]};
  padding: 0 ${layout.gutter};
  text-align: center;
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
